import { useEffect, useRef, useState } from "react";
import { Sparkles, RefreshCw } from "lucide-react";
import { api } from "@/lib/api";
import { streamAI } from "@/lib/aiStream";
import { Button } from "@/components/ui/button";

export function AiText({ text }) {
  return text.split(/(\*\*[^*]+\*\*)/g).map((p, i) => (p.startsWith("**") && p.endsWith("**") ? <b key={i}>{p.slice(2, -2)}</b> : p.replace(/^#{1,4}\s/gm, "").replace(/^\s*[*-]\s/gm, "• ").replace(/\*([^*\n]+)\*/g, "$1")));
}

export function AiDailySummary() {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const started = useRef(false);
  const generate = async () => {
    setBusy(true); setError(""); setText("");
    try { await streamAI("/ai/daily-summary/generate", {}, (t) => setText((p) => p + t)); } catch (e) { setError(e.message); } finally { setBusy(false); }
  };
  useEffect(() => {
    if (started.current) return;
    started.current = true;
    api.get("/ai/daily-summary").then((r) => { if (r.data.text) setText(r.data.text); else generate(); }).catch(() => {});
  }, []);
  return (
    <div className="mt-4 rounded-2xl border border-sky-200 bg-gradient-to-br from-white to-sky-50 p-4 rise rise-2" data-testid="ai-daily-summary">
      <div className="flex items-center gap-2">
        <span className="h-8 w-8 rounded-full bg-slate-900 text-sky-300 flex items-center justify-center"><Sparkles className="h-4 w-4" /></span>
        <div className="font-bold text-slate-800">Ringkasan Harian AI</div>
        <Button variant="ghost" size="sm" className="ml-auto h-8 text-sky-700" disabled={busy} onClick={generate} data-testid="btn-ai-summary-refresh"><RefreshCw className={`h-3.5 w-3.5 mr-1 ${busy ? "animate-spin" : ""}`} /> Perbarui</Button>
      </div>
      {error ? <p className="mt-2 text-sm text-rose-600" data-testid="ai-summary-error">{error}</p>
        : <p className="mt-2 text-sm text-slate-700 whitespace-pre-wrap leading-relaxed" data-testid="ai-summary-text"><AiText text={text || (busy ? "Menyusun ringkasan…" : "")} /></p>}
    </div>
  );
}

export function AiReportInsight({ period, refDate }) {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true); setText("");
    try { await streamAI("/ai/report-insight", { period, ref_date: refDate }, (t) => setText((p) => p + t)); } catch (e) { setText(`⚠ ${e.message}`); } finally { setBusy(false); }
  };
  return (
    <div className="card-aqua p-4 mb-4" data-testid="ai-report-insight">
      <div className="flex items-center gap-2">
        <Sparkles className="h-4 w-4 text-sky-600" /><span className="font-bold text-slate-800">Analisis & Saran AI</span>
        <Button size="sm" className="ml-auto rounded-full bg-slate-900 hover:bg-slate-800" disabled={busy} onClick={run} data-testid="btn-ai-report-insight">{busy ? "Menganalisis…" : text ? "Analisis Ulang" : "Analisis Periode Ini"}</Button>
      </div>
      {text && <p className="mt-3 text-sm text-slate-700 whitespace-pre-wrap leading-relaxed" data-testid="ai-report-text"><AiText text={text} /></p>}
    </div>
  );
}
